import React from 'react'
import ReactDOM from 'react-dom/client'
import {Provider} from "react-redux"
import reportWebVitals from '../src/reportWebVitals'
import {RouterProvider} from 'react-router'
import store from "../src/app/store.jsx"
import Router from "../src/app/Router"
import AuthMiddleware from '../src/app/AuthMiddleware'

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <Provider store={store}>
            <AuthMiddleware>
                <RouterProvider router={Router(store)} fallbackElement={<>Just Blank!</>}/>
            </AuthMiddleware>
        </Provider>
    </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
